// ============================================================================
// The Hive — app shell entry point
// Builds the sidebar (from the module registry), topbar, and mounts the router.
// Phase 1: structure + navigation + branded placeholders. No behavior yet.
// ============================================================================
import './styles/base.css'
import { MODULES } from './modules/registry.js'
import { startRouter } from './lib/router.js'
import { HEX_MARK, icon } from './lib/icons.js'
import { api } from './lib/api.js'

const app = document.getElementById('app')

// ---- Sidebar (grouped, in registry order) ----
const groups = []
for (const m of MODULES) {
  let g = groups.find(x => x.name === m.group)
  if (!g) { g = { name: m.group, items: [] }; groups.push(g) }
  g.items.push(m)
}
const tag = (m) =>
  m.status === 'deferred' ? '<span class="tag">later</span>'
  : m.status === 'soon'   ? '<span class="tag soon">soon</span>'
  : ''
const navHtml = groups.map(g => `
  <div class="group">${g.name}</div>
  ${g.items.map(m => `
    <a class="item" data-id="${m.id}" href="#/${m.id}" title="${m.role}">
      ${m.iconSvg}<span>${m.label}</span>${tag(m)}
    </a>`).join('')}
`).join('')

app.innerHTML = `
  <aside class="side" id="side">
    <div class="brand">
      <img class="glogo" src="/brand/giggle-g.png" alt="Giggle" />
      <div class="name">The Hive<small>Giggle Messaging</small></div>
    </div>
    <nav class="nav">${navHtml}</nav>
    <div class="foot">
      <div class="who" id="who">Signed in</div>
      <div class="footrow"><span id="whoRole">—</span><button class="signout" id="signout" type="button">Sign out</button></div>
    </div>
  </aside>
  <main class="main">
    <header class="topbar">
      <button class="icon-btn" id="menuBtn" aria-label="Menu" style="display:none">${icon('hive')}</button>
      <div>
        <h1 id="topTitle">The Hive</h1>
        <div class="sub" id="topSub"></div>
      </div>
      <div class="spacer"></div>
      <button class="icon-btn" id="themeBtn" aria-label="Toggle theme">${icon('moon')}</button>
    </header>
    <div class="content" id="content"></div>
  </main>
`

// ---- Router ----
startRouter({
  content: document.getElementById('content'),
  topTitle: document.getElementById('topTitle'),
  topSub: document.getElementById('topSub'),
})

// ---- Theme toggle (persists) ----
const themeBtn = document.getElementById('themeBtn')
const saved = localStorage.getItem('hive_theme')
if (saved) document.documentElement.dataset.theme = saved
themeBtn.addEventListener('click', () => {
  const cur = document.documentElement.dataset.theme
    || (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
  const next = cur === 'dark' ? 'light' : 'dark'
  document.documentElement.dataset.theme = next
  localStorage.setItem('hive_theme', next)
})

// ---- Mobile menu ----
const menuBtn = document.getElementById('menuBtn')
menuBtn.addEventListener('click', () => document.getElementById('side').classList.toggle('open'))
const mq = matchMedia('(max-width: 900px)')
const syncMenu = () => { menuBtn.style.display = mq.matches ? 'grid' : 'none' }
mq.addEventListener('change', syncMenu); syncMenu()

// ---- Who am I (RBAC context); harmless if backend not up yet in `vite dev` ----
api.me().then(u => {
  if (!u) return
  document.getElementById('who').textContent = u.name || u.email || 'Signed in'
  document.getElementById('whoRole').textContent = u.role ? `Role: ${u.role}` : ''
}).catch(() => { document.getElementById('whoRole').textContent = 'demo mode' })

// ---- Sign out ----
document.getElementById('signout').addEventListener('click', async () => {
  try { await fetch('/api/logout', { method: 'POST', credentials: 'same-origin' }) } catch {}
  location.href = '/login'
})
